import React from "react";

function RetryIcon() {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.646 12.75C7.646 12.9489 7.56698 13.1397 7.42633 13.2803C7.28568 13.421 7.09491 13.5 6.896 13.5C3.104 13.5 0 10.495 0 6.75C0 3.005 3.104 0 6.896 0C10.001 0 12.645 2.015 13.501 4.801L14.104 3.781C14.2052 3.60967 14.3703 3.48555 14.563 3.43595C14.7557 3.38634 14.9602 3.41532 15.1315 3.5165C15.3028 3.61768 15.4269 3.78278 15.4766 3.97547C15.5262 4.16816 15.4972 4.37267 15.396 4.544L13.766 7.299C13.6662 7.468 13.5041 7.59115 13.3145 7.642C13.125 7.69285 12.923 7.66736 12.752 7.571L9.93 5.98C9.84418 5.93161 9.76873 5.86679 9.70797 5.78924C9.6472 5.71169 9.6023 5.62293 9.57584 5.52803C9.54937 5.43312 9.54186 5.33394 9.55373 5.23613C9.56559 5.13833 9.59661 5.04382 9.645 4.958C9.69339 4.87218 9.75821 4.79673 9.83576 4.73597C9.91331 4.6752 10.0021 4.6303 10.097 4.60384C10.1919 4.57737 10.2911 4.56986 10.3889 4.58173C10.4867 4.59359 10.5812 4.62461 10.667 4.673L12.139 5.503C11.565 3.215 9.448 1.5 6.897 1.5C3.899 1.5 1.5 3.867 1.5 6.75C1.5 9.633 3.899 12 6.896 12C7.09491 12 7.28568 12.079 7.42633 12.2197C7.56698 12.3603 7.646 12.5511 7.646 12.75Z"
        fill="#F44336"
      />
    </svg>
  );
}

export default RetryIcon;
